import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-surgery',
  templateUrl: './add-surgery.component.html',
  styleUrls: ['./add-surgery.component.scss']
})
export class AddSurgeryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }


}
